import { useOutletContext } from "react-router-dom";
import { LayoutDashboard, Layers, Users, KeyRound, UserCog, Settings } from "lucide-react";

/** Pages of the organization portal; each is its own route under /org. */
export const ORG_PAGES = [
    { key: "overview", path: "", label: "Overview", icon: LayoutDashboard },
    { key: "programs", path: "programs", label: "Programs", icon: Layers },
    { key: "students", path: "students", label: "Students", icon: Users },
    { key: "licenses", path: "licenses", label: "Licenses", icon: KeyRound, adminOnly: true },
    { key: "staff", path: "staff", label: "Coaches & Admins", icon: UserCog, adminOnly: true },
    { key: "settings", path: "settings", label: "Settings", icon: Settings, adminOnly: true },
];

/** URL for an org page, keeping ?orgId= when the viewer picked a specific org. */
export function orgPagePath(key, { orgId, ...extra } = {}) {
    const page = ORG_PAGES.find((p) => p.key === key) || ORG_PAGES[0];
    const params = new URLSearchParams();
    if (orgId) params.set("orgId", orgId);
    Object.entries(extra).forEach(([k, v]) => { if (v) params.set(k, v); });
    const qs = params.toString();
    return `/org${page.path ? `/${page.path}` : ""}${qs ? `?${qs}` : ""}`;
}

/**
 * Shared state OrgLayout hands to every org page:
 * { orgId, org, viewer, isOrgAdmin, isPlatformAdmin, reloadOrg, goTo(key, extraParams) }
 */
export const useOrgPortal = () => useOutletContext();
